export default __webpack_public_path__ + "static/media/facebook-f.5eaede3b.svg";